export default {
    name: "phoneNumbers",
    _links: null,
    init() {
        this._links = document.querySelectorAll("a[href^='tel']");
        if (!this._links) {
            return;
        }

        for (const link of this._links) {
            const text = link.innerText;
            link.innerText =  link.dataset.title ?? '';
            link.addEventListener('click', (e) => {
                if (link.innerText === link.dataset.title) e.preventDefault();
                link.innerText = text;
            });
        }
    }
}